module.exports = __webpack_public_path__ + "img/fcs.50977b1d.svg";